import React from 'react';
import { resolveImageUrl } from "../../constants";
import { travelcard_image as image } from '../../assets/images/images/index';
import "./hotelcard.css";
import { useTranslation } from 'react-i18next';

export default function Hotelcard({ hotel }) {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  const getLocalizedText = (defaultText, arabicText) => {
    return isRTL && arabicText ? arabicText : defaultText;
  };

  const backgroundUrl = hotel?.images?.[0]?.url
    ? resolveImageUrl(hotel.images[0].url.replace(/\\/g, "/"))
    : image;

  const parseServices = (services) => {
    if (Array.isArray(services)) return services;
    if (typeof services === 'string') {
      try {
        const parsed = JSON.parse(services);
        if (Array.isArray(parsed)) return parsed.map(s => typeof s === 'string' ? s : s.name || String(s));
      } catch { /* not JSON */ }
    }
    return [];
  };

  const parsedServices = parseServices(hotel?.services);
  const servicesToShow = parsedServices.slice(0, 3);

  const handleClick = () => {
    if (hotel?.code) window.location.href = `/hotel-one/${hotel.code}`;
  };

  return (
    <div className={`Hotelcard ${isRTL ? "rtl" : ""}`} onClick={handleClick}>
      <div className="hc_image_wrapper">
        <img src={backgroundUrl} alt={hotel?.name || "hotel"} className="hc_image" />
        {hotel?.type && <span className="hc_type_badge">{hotel.type}</span>}
      </div>

      <div className="hc_body">
        <div className="hc_header_row">
          <h3 className="hc_title">
            {getLocalizedText(hotel?.name || t('hotelcard.defaultName'), hotel?.name_ar)}
          </h3>
          <div className="hc_rating">
            <span className="hc_rating_star">★</span>
            <span className="hc_rating_value">4.6</span>
          </div>
        </div>

        <p className="hc_location">
          <span className="hc_pin">📍</span>
          {hotel?.state || t('hotelcard.defaultLocation')}
        </p>

        {servicesToShow.length > 0 && (
          <div className="hc_services">
            {servicesToShow.map((service, index) => (
              <span key={index} className="hc_service_chip">{service}</span>
            ))}
            {parsedServices.length > 3 && (
              <span className="hc_service_more">+{parsedServices.length - 3}</span>
            )}
          </div>
        )}

        <div className="hc_footer">
          <div className="hc_price">
            <span className="hc_price_from">{t('hotelcard.from') || 'From'}</span>
            <span className="hc_price_amount">
              {hotel?.startprice ? Number(hotel.startprice).toLocaleString() : '—'} DA
            </span>
            <span className="hc_price_unit">/ {t('hotelcard.night') || 'night'}</span>
          </div>
          <button className="hc_cta" onClick={(e) => { e.stopPropagation(); handleClick(); }}>
            {t('hotelcard.seeMore')}
          </button>
        </div>
      </div>
    </div>
  );
}
